<template>
  <header class="top-bar">
    <div class="left-section">
      <div class="breadcrumb">
        <span class="current-page">{{ currentPageTitle }}</span>
      </div>
    </div>

    <div class="right-section">
      <div class="search-container">
        <input
          v-model="searchQuery"
          placeholder="搜索历史睡眠和抑郁症报告..."
          class="search-input"
        />
        <i class="fas fa-search search-icon"></i>
      </div>

      <div class="user-info">
        <div class="notification">
          <i class="fas fa-bell"></i>
          <span class="badge">{{Math.floor(Math.random() * 39) + 1}}</span>
        </div>
        <div class="doctor-profile">
          <img 
            :src="require('@/assets/images/patientAvatar.jpg')"
            class="doctor-avatar"
            alt="医生头像"
          />
          <div class="doctor-details">
            <span class="doctor-name">{{doctorName}}</span>
            <span class="doctor-title">病人</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import {useUserStore} from "@/store";

export default {
  name: 'TopBar',
  data() {
    return {
      doctorName: '',
      doctorTitle: '',
      searchQuery: '',
      currentPageTitle: '睡眠信号监测'
    }
  },
  watch: {
    $route(to) {
      this.updatePageTitle(to.name)
    }
  },
  mounted() {
    this.updatePageTitle(this.$route.name)
  },
  methods: {
    updatePageTitle(routeName) {
      const menuItems= [
        { 
          path: '/eeg-record', 
          name: 'EEGRecord',
          title: '我的睡眠记录', 
          icon: 'fas fa-brain' 
        },
        { 
          path: '/sleep-report', 
          name: 'SleepReport',
          title: '睡眠报告分析', 
          icon: 'fas fa-moon' 
        },
        { 
          path: '/ai', 
          name: 'AI',
          title: '失眠陪伴助手', 
          icon: 'fas fa-comments' 
        },
        { 
          path: '/reference', 
          name: 'Reference',
          title: '知识科普', 
          icon: 'fas fa-chart-line' 
        },
        { 
          path: '/account-settings', 
          name: 'AccountSettings',
          title: '账户设置', 
          icon: 'fas fa-user-cog' 
        }
      ];
      const matchedItem = menuItems.find(item => item.name === routeName);
      this.currentPageTitle = matchedItem ? matchedItem.title : '心鉴智愈系统';
      const Store = useUserStore();
      this.doctorName = Store.userInfo ? Store.userInfo.name : ""
    }
  
  }
}
</script>

<style scoped>
.top-bar {
  height: min(70px, 9.7vh);
  background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),
    url('@/assets/images/docs@30.8b9a76a2.avif') center/cover;
  background-size: cover;
  background-position: center;
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 min(15px, 2vw);
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  z-index: 999;
  position: relative;
  font-size: min(16px, 2.2vw);
}

.top-bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: inherit;
  backdrop-filter: blur(5px);
  z-index: -1;
}

.left-section {
  flex: 1;
}

.breadcrumb {
  font-size: min(20px, 2.8vw);
  font-weight: 500;
  color: #333;
  margin-bottom: 0 !important;
}

.current-page {
  position: relative;
  padding-left: 25px;
}

.current-page::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: var(--secondary-color);
  border-radius: 2px;
}

.right-section {
  display: flex;
  align-items: center;
  gap: 30px;
}

.search-container {
  position: relative;
  width: auto;
  
}

.search-input {
  width: min(300px, 41.7vw);
  height: min(40px, 5.6vh);
  padding: 0 min(40px, 5.6vw) 0 min(20px, 2.8vw);
  border: 1px solid #e6e6ff;
  border-radius: min(20px, 2.8vw);
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: min(14px, 1.9vw);
}

.search-input:focus {
  border-color: var(--secondary-color);
  outline: 2px solid var(--secondary-color); /* 更粗的选中焦点边框 */
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.2); /* 柔和的阴影 */
}

.search-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 25px;
}

.notification {
  position: relative;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;
}

.notification:hover {
  color: var(--secondary-color);
}

.badge {
  position: absolute;
  top: -6px;
  right: -8px;
  background: #ff4757;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
}

.doctor-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}

.doctor-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.doctor-details {
  display: flex;
  flex-direction: column;
}

.doctor-name {
  font-weight: 500;
  font-size: 14px;
}

.doctor-title {
  font-size: 12px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-bar {
    left: min(60px, 8.3vw);
    padding: 0 min(15px, 2vw);
    height: min(60px, 8.3vh);
  }
  
  .search-container {
    width: min(180px, 25vw);
  }
  
  .current-page {
    font-size: min(16px, 2.2vw);
    padding-left: min(20px, 2.8vw);
  }
  
  .current-page::before {
    height: min(16px, 2.2vh);
    width: min(4px, 0.6vw);
  }
  
  .right-section {
    gap: min(15px, 2vw);
  }
  
  .doctor-details {
    display: none;
  }
  
  .doctor-avatar {
    width: min(40px, 5.6vw);
    height: min(40px, 5.6vw);
  }
  
  .search-input {
    height: min(40px, 5.6vh);
    font-size: min(14px, 1.9vw);
  }
  
  .badge {
    font-size: min(12px, 1.7vw);
    padding: min(2px, 0.3vh) min(6px, 0.8vw);
  }
}
</style>